// models/RatingType.ts

import { RatingTypeType } from '../enums/enums';

export interface RatingType {
  id: number;
  boxId: number;
  name: string;
  description: string;
  order: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: number;
  updatedBy: number;
  isDeleted: number;
}

export const parseRatingType = (json: any): RatingType => ({
  id: json.id,
  boxId: json.box_id,
  name: json.name,
  description: json.description,
  order: json.order,
  createdAt: new Date(json.created_at),
  updatedAt: new Date(json.updated_at),
  createdBy: json.created_by,
  updatedBy: json.updated_by,
  isDeleted: json.is_deleted,
});

export const serializeRatingType = (rt: RatingType): any => ({
  id: rt.id,
  box_id: rt.boxId,
  name: rt.name,
  description: rt.description,
  order: rt.order,
  created_at: rt.createdAt.toISOString(),
  updated_at: rt.updatedAt.toISOString(),
  created_by: rt.createdBy,
  updated_by: rt.updatedBy,
  is_deleted: rt.isDeleted,
});

// Map string name to enum value
export const getRatingTypeType = (name: string): RatingTypeType => {
  switch (name) {
    case 'Tiempo':
      return RatingTypeType.time;
    case 'Rondas':
      return RatingTypeType.rounds;
    case 'Reps':
      return RatingTypeType.reps;
    case 'Kg':
      return RatingTypeType.weightKg;
    case 'Calorias':
      return RatingTypeType.calories;
    case 'm':
      return RatingTypeType.meters;
    case 'Km':
      return RatingTypeType.kilometers;
    case 'Vatios':
      return RatingTypeType.vatios;
    default:
      return RatingTypeType.time;
  }
};
